/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../login/login.model.ts" />
/// <reference path="../cookies/cookies.service.ts" />

module Eseebase {
    export class BaseService {
        constructor(private $http: ng.IHttpService, private cookiesService: CookiesService) { }

        public get(url: string) {
            return this.$http.get(`/${url}`);
        }

        public getArrayBuffer(url: string) {
            return this.$http.get(`/${url}`, { responseType: 'arraybuffer' });
        }

        public postArrayBuffer(url: string, data: any) {
            return this.$http.post(`/${url}`, data, { responseType: 'arraybuffer' });
        }

        public post(url: string, data: any) {
            return this.$http.post(`/${url}`, data);
        }

        public put(url: string, data: any) {
            return this.$http.put(`/${url}`, data);
        }

        public delete(url: string) {
            return this.$http.delete(`/${url}`);
        }

        public postAsForm(url: string, data: any, absoluteUrl?: boolean) {
            return this.$http({
                method: 'POST',
                url: absoluteUrl ? url : `/${url}`,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                data: data
            });
        }

        public upload(url: string, data: any, onProgress?: Function) {
            return this.$http({
                method: 'POST',
                url: `/${url}`,
                headers: { 'Content-Type': undefined },
                withCredentials: true,
                transformRequest: angular.identity,
                data: data,
                uploadEventHandlers: {
                    progress: function (e: any) {
                        if (e.lengthComputable && onProgress != null) {
                            onProgress((e.loaded / e.total) * 24);
                        }
                    }
                },
            });
        }

        public getAccessToken()
        {
            return this.cookiesService.readCookie('accessToken');
        }

        public saveAccessToken(accessToken: string) {
            this.cookiesService.createCookie('accessToken', accessToken, 0);
        }

        public saveStorageAccessToken(accessToken: string) {
            this.cookiesService.createCookie('storageAccessToken', accessToken, 0);
        }

        public saveRefreshToken(refreshToken: string, store: boolean) {
            this.cookiesService.createCookie('refreshToken', refreshToken, store ? 144000 : 0);
        }

        public removeAccessToken() {
            this.cookiesService.deleteCookie('accessToken');
            this.cookiesService.deleteCookie('refreshToken');
            this.cookiesService.deleteCookie('storageAccessToken');
        }
    }

    BaseService.$inject = ['$http', 'CookiesService'];
    angular
        .module('eseebase')
        .service('BaseService', BaseService);
}